(function($window) {
    /**
     * Creates object to control "exit popup".
     *
     */
    function ExitPopup() {
        this.options = {
            triggerSelector: '.subscribe-popup',
            contentSelector: '.content',
            countdown: 2,
            cta: '',
            scroll: 50,
            showModal: null,
            modalTitleSelector: '',
            ctaStrings: []
        };

        this.attributes = ['cta', 'countdown', 'scroll']; // data-attributes to parse

        this.isFired = false;
        this.isShown = false;
    }

    /**
     * Try to init popup.
     *
     * If data-attributes were passed to triggerElement
     * they will be stored to object options with the highest priority.
     *
     * @param {object} options - Object to merge with default params.
     * @param {string} options.triggerSelector - selector to find element that triggers whole logic.
     * @param {string} options.contentSelector - selector for scrollable content area.
     * @param {string} options.modalTitleSelector - selector for popup title.
     * @param {string} options.cta - text for popup title.
     * @param {int} options.countdown - seconds to elapse before show popup.
     * @param {int} options.scroll - percent of content area after need to show popup.
     * @param {function} options.showModal - how to call the modal.
     * @param {array} options.ctaStrings - CTA strings list.
     *
     * @return {boolean}
     */
    ExitPopup.prototype.init = function(options) {
        $.extend(this.options, options);

        this.$triggerElement = $(this.options.triggerSelector).eq(0);
        this.$contentElement = $(this.options.contentSelector).eq(0);
        this.$modalTitleElement = $(this.options.modalTitleSelector).eq(0);

        if (!this.$triggerElement.length || !this.$contentElement.length || !this.options.showModal) {
            return false;
        }

        this.parseDataAttributes();

        if (!this.options.cta) {
            this.generateCTA();
        }

        if (this.scrollReachedThreshold()) {
            return false;
        }

        // console.log(this.options);

        // this.handleScrolling();

        this.handleResize();
        this.handleUserEscape();

        return true;
    };

    /**
     * Modify options by getting options from data-attributes.
     */
    ExitPopup.prototype.parseDataAttributes = function() {
        for (var i in this.attributes) {
            var val = this.$triggerElement.data(this.attributes[i]);
            if (val || val === 0) {
                this.options[this.attributes[i]] = val;
            }
        }
    };

    /**
     * Get content area top offset.
     */
    ExitPopup.prototype.calcContentOffsetTop = function() {
        return this.$contentElement.offset().top;
    };

    /**
     * Get content area height.
     */
    ExitPopup.prototype.calcContentHeight = function() {
        return this.$contentElement.height();
    };

    /**
     * Get cached content area top offset.
     */
    ExitPopup.prototype.getContentOffsetTop = function() {
        if (typeof this.contentOffsetTop === 'undefined') {
            this.contentOffsetTop = this.calcContentOffsetTop();
        }
        return this.contentOffsetTop;
    };

    /**
     * Get cached content area height.
     */
    ExitPopup.prototype.getContentHeight = function() {
        if (typeof this.contentHeight === 'undefined') {
            this.contentHeight = this.calcContentHeight();
        }
        return this.contentHeight;
    };

    /**
     * Watch for scroll events and fire popup if needed.
     */
    ExitPopup.prototype.handleScrolling = function() {
        $window.on('scroll', $.throttle(250, this.show.bind(this)));
    };

    /**
     * Return true if scroll position has reached the % bound.
     * @return {boolean}
     */
    ExitPopup.prototype.scrollReachedThreshold = function() {
        var offsetTop = parseFloat(this.getContentOffsetTop());
        var height = this.getContentHeight();
        var ratio = 100 / parseInt(this.options.scroll);
        var space = document.documentElement.clientHeight - offsetTop;

        if (!isFinite(ratio)) {
            ratio = height;
        }

        var threshold = Math.floor(parseFloat(height / ratio) + offsetTop + space);
        threshold -= document.documentElement.clientHeight;

        return $window.scrollTop() >= threshold;
    };

    /**
     * Watch window resize to re-calculate offsets.
     */
    ExitPopup.prototype.handleResize = function() {
        function calc() {
            this.contentOffsetTop = this.calcContentOffsetTop();
            this.contentHeight = this.calcContentHeight();
        }
        $window.on('resize', $.throttle(250, calc.bind(this)));
    };

    /**
     * Generate random CTA from list.
     */
    ExitPopup.prototype.generateCTA = function() {
        if (this.options.ctaStrings.length > 0) {
            this.options.cta = this.options.ctaStrings[getRandomInt(0, this.options.ctaStrings.length)];
        }
    };

    /**
     * Replace popup title if selector and cta passed.
     */
    ExitPopup.prototype.updatePopupTitle = function() {
        if (this.$modalTitleElement && this.options.cta) {
            this.$modalTitleElement.text(this.options.cta);
        }
    };

    /**
     * Shows popup.
     */
    ExitPopup.prototype.show = function() {
        if (!this.isFired && !this.isShown) {
            if (this.scrollReachedThreshold()) {
                this.isFired = true;
                setTimeout(
                    function(_this) {
                        _this.updatePopupTitle();
                        _this.options.showModal();
                        _this.isShown = true;
                    },
                    parseInt(this.options.countdown) * 1000,
                    this
                );
            }
        }
    };

    /**
     * Show popup immediately.
     */
    ExitPopup.prototype.showImmediately = function() {
        if (!this.isFired && !this.isShown) {
            this.isFired = true;
            this.isShown = true;
            this.updatePopupTitle();
            this.options.showModal();
        }
    };

    /**
     * Watch for user mouse and show popup if he wants to close our awesome page.
     */
    ExitPopup.prototype.handleUserEscape = function() {
        var _this = this;
        var sensitivity = 20;
        var delay = 0;
        var delayTimer = null;

        setTimeout(attachEvents, 1000);

        function attachEvents() {
            document.documentElement.addEventListener('mouseleave', handleMouseleave);
            document.documentElement.addEventListener('mouseenter', handleMouseenter);
            document.documentElement.addEventListener('keydown', handleKeydown);
        }

        function handleMouseleave(e) {
            if (e.clientY > sensitivity) {
                return;
            }
            delayTimer = setTimeout(firePopup, delay);
        }

        function handleMouseenter() {
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        }

        var disableKeydown = false;

        function handleKeydown(e) {
            if (disableKeydown) {
                return;
            } else if (!e.metaKey || e.keyCode !== 76) {
                return;
            }
            disableKeydown = true;
            delayTimer = setTimeout(firePopup, delay);
        }

        function firePopup() {
            _this.showImmediately();
            document.documentElement.removeEventListener('mouseleave', handleMouseleave);
            document.documentElement.removeEventListener('mouseenter', handleMouseenter);
            document.documentElement.removeEventListener('keydown', handleKeydown);
        }
    };

    /**
     * Return random integer value from start to end
     *
     * @param {int} start minimal number of random
     * @param {int} end maximal number of random
     * @return {int} random integer number
     */
    function getRandomInt(start, end) {
        end = end || start;
        return Math.floor(Math.random() * (end - start + 1)) + start;
    }

    window.ExitPopup = ExitPopup;
})($(window));



// WEBPACK FOOTER //
// ./assets/js/common/modules/exit-popup.js